import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-examination-committee',
  templateUrl: './examination-committee.component.html',
  styleUrls: ['./examination-committee.component.scss']
})
export class ExaminationCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
